import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import axiosInstance from '../../config';
import CurrencyFormat from 'react-currency-format';
import AgentUtils from '../../agentutils';

const BigWinner = ( {User}) => {
  const [user, setUser] = useState(null);
  const [agentType, setAgentType] = useState('');
  const [processedWeekBuckets, setProcessedWeekBuckets] = useState([]);

  // Get filtered agent types based on user role
  const getFilteredAgentTypes = () => {
    const userRole = AgentUtils.getCurrentLevel(sessionStorage.getItem('me')).toUpperCase();
    console.log('userRole: '+userRole);
    switch (userRole) {
      case 'COMPANY':
        return ["VENDOR", "SENIOR", "MASTER", "AGENT", "MEMBER"];
      case 'VENDOR':
        return ["SENIOR", "MASTER", "AGENT", "MEMBER"];
      case 'SENIOR':
        return ["MASTER", "AGENT", "MEMBER"];
      case 'MASTER':
        return ["AGENT", "MEMBER"];
      case 'AGENT':
        return ["MEMBER"];
      case 'MEMBER':
        return [];
      default:
        return [];
    }
  };

  // Get week data for a specific user and week
  const getWeekData = (userData, weekStart, weekEnd) => {
    if (!userData.weeklyReports) return { turnover: 0, win: 0 };
    
    const weekData = userData.weeklyReports.find(report => {
      const reportDate = new Date(report.weekStartDate);
      return reportDate >= weekStart && reportDate <= weekEnd;
    });
    
    if (weekData) {
      return {
        turnover: weekData.turnover || 0,
        win: weekData.win || 0
      };
    }
    
    return { turnover: 0, win: 0 };
  };

  // Process week buckets from mondays array
  const processWeekBuckets = (mondays) => {
    if (!mondays || mondays.length === 0) return [];
    
    const buckets = [];
    mondays.forEach((monday, index) => {
      // Extract only the date part (YYYY-MM-DD) from the timestamp, ignoring time and timezone
      const dateString = monday.split('T')[0];
      const weekStart = new Date(dateString);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      
      const startMonth = weekStart.getMonth() + 1;
      const startDay = weekStart.getDate();
      const endMonth = weekEnd.getMonth() + 1;
      const endDay = weekEnd.getDate();
      
      buckets.push({
        startDate: weekStart,
        endDate: weekEnd,
        label: `${startMonth}/${startDay} - ${endMonth}/${endDay}`,
        weekNumber: index + 1
      });
    });
    
    return buckets;
  };

  const handleChange = (e, value) => {
    if (e != null) e.preventDefault();
      let search = document.getElementById('member-id').value;
      axiosInstance
        .get('agent/playerSummaryTurnoverWinByWeek', {
          params: {
            username: search ? search : null,
            agentType: agentType === 'MEMBER' ? null : agentType,
          },
        })
        .then((res) => {
          // Process week buckets from mondays array
          const weekBuckets = processWeekBuckets(res.data.mondays);
          setProcessedWeekBuckets(weekBuckets);
          
          // Sort data by betCreatedBy in ascending order
          const sortedData = res.data.weeklyTurnoverWinReports.sort((a, b) => a.betCreatedBy.localeCompare(b.betCreatedBy));
          setUser(sortedData);
        })
        .catch((err) => console.log(err));
    
  };

  useEffect(() => {
    handleChange(null);
  }, [agentType]);

  return (
    <>
      <Navbar User={User}/>
      <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
        <form action="" onSubmit={handleChange} id="bw-form">
          
          <label htmlFor="member-id mx-2">Login ID: </label>
          <input type="text" id="member-id" className="mx-2" />
          
          <select
            name=""
            id="agent-type"
            style={{ minWidth: '120px' }}
            className="py-1 mx-2"
            onChange={(e) => setAgentType(e.target.value)}
            value={agentType}
          >
            <option value="">Select Agent Type</option>
            {getFilteredAgentTypes().map((type, index) => (
              <option key={index} value={type}>{type}</option>
            ))}
          </select>
          <input
            type="submit"
            value="Get Report"
            className="btn btn-sm btn-primary px-1 py-1 mx-1"
          />
          
        </form>
      </div>
      {/* table for weekly report */}
      {user !== null ? (
        <>
          <div className="table-responsive-sm mx-2">
            <table className="table table-sm table-striped table-bordered">
              <thead className="text-center thead-dark">
                <tr>
                  <th>No.</th>
                  <th>Login ID</th>
                  {processedWeekBuckets.map((week, index) => (
                    <th key={index}>Week {week.weekNumber}<br/>({week.label})</th>
                  ))}
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {user.map((info, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{info.betCreatedBy}</td>
                    {processedWeekBuckets.map((week, weekIndex) => {
                      const weekData = getWeekData(info, week.startDate, week.endDate);
                      return (
                        <td key={weekIndex} className="text-right">
                          <div style={{ lineHeight: '1.2' }}>
                            <div style={{ 
                              color: weekData.turnover < 0 ? 'red' : 'black',
                              marginBottom: '4px'
                            }}>
                              <CurrencyFormat
                                value={weekData.turnover}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </div>
                            <div style={{ 
                              color: weekData.win < 0 ? 'red' : 'black'
                            }}>
                              <CurrencyFormat
                                value={weekData.win}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </div>
                          </div>
                        </td>
                      );
                    })}
                    <td className="text-right">
                      <div style={{ lineHeight: '1.2' }}>
                        <div style={{ 
                          color: info.totalTurnover < 0 ? 'red' : 'black',
                          marginBottom: '4px'
                        }}>
                          <CurrencyFormat
                            value={info.totalTurnover}
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                          />
                        </div>
                        <div style={{ 
                          color: info.totalWin < 0 ? 'red' : 'black'
                        }}>
                          <CurrencyFormat
                            value={info.totalWin}
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
                {/* Total Row */}
                <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                  <td className="text-center" style={{ fontWeight: 'bold' }}>Total</td>
                  <td className="text-center" style={{ fontWeight: 'bold' }}></td>
                  {processedWeekBuckets.map((week, weekIndex) => {
                    // Calculate totals for this week
                    const weekTotals = user.reduce((acc, info) => {
                      const weekData = getWeekData(info, week.startDate, week.endDate);
                      return {
                        turnover: acc.turnover + weekData.turnover,
                        win: acc.win + weekData.win
                      };
                    }, { turnover: 0, win: 0 });
                    
                    return (
                      <td key={weekIndex} className="text-right">
                        <div style={{ lineHeight: '1.2' }}>
                          <div style={{ 
                            color: weekTotals.turnover < 0 ? 'red' : 'black',
                            marginBottom: '4px',
                            fontWeight: 'bold'
                          }}>
                            <CurrencyFormat
                              value={weekTotals.turnover}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </div>
                          <div style={{ 
                            color: weekTotals.win < 0 ? 'red' : 'black',
                            fontWeight: 'bold'
                          }}>
                            <CurrencyFormat
                              value={weekTotals.win}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </div>
                        </div>
                      </td>
                    );
                  })}
                  <td className="text-right">
                    <div style={{ lineHeight: '1.2' }}>
                      <div style={{ 
                        color: user.reduce((sum, info) => sum + (info.totalTurnover || 0), 0) < 0 ? 'red' : 'black',
                        marginBottom: '4px',
                        fontWeight: 'bold'
                      }}>
                        <CurrencyFormat
                          value={user.reduce((sum, info) => sum + (info.totalTurnover || 0), 0)}
                          decimalScale={2}
                          displayType={'text'}
                          thousandSeparator={true}
                          fixedDecimalScale={true}
                        />
                      </div>
                      <div style={{ 
                        color: user.reduce((sum, info) => sum + (info.totalWin || 0), 0) < 0 ? 'red' : 'black',
                        fontWeight: 'bold'
                      }}>
                        <CurrencyFormat
                          value={user.reduce((sum, info) => sum + (info.totalWin || 0), 0)}
                          decimalScale={2}
                          displayType={'text'}
                          thousandSeparator={true}
                          fixedDecimalScale={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </>
  );
};

export default BigWinner;
